import { contractresignationreasons } from 'rest/urls'
import useFetchedData from 'hooks/useFetchedData'
import useTranslation from 'hooks/useTranslation'
import Select from 'components/inputs/Select'
import Input from 'components/inputs/Input'
import React from 'react'

interface Reason {
  id: string
  key: string
  name: string
}

interface ReasonSelectProps {
  disabled?: boolean
  selectedData?: payments.SelectedData
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
}

const ReasonSelect: React.FC<ReasonSelectProps> = ({ selectedData, disabled, selectData }) => {
  const { isLoading, data } = useFetchedData<Reason[]>(contractresignationreasons, 'data', 'GET')
  const { t } = useTranslation('warehouse')
  return (
    <>
      <Select
        secondaryTheme
        label={t('reason')}
        disabled={disabled || isLoading}
        value={selectedData?.reasonId}
        setValue={reasonId => {
          selectData(prev => {
            const { reason, ...rest } = prev
            return {
              ...rest,
              reasonId
            }
          })
        }}
        options={
          data
            ? data.map(r => ({ name: r.name, value: r.id }))
            : []
        }
      />

      {selectedData?.reasonId && data && data.find(r => r.id === selectedData.reasonId)?.key === 'other_reason' && <Input
        name='reason'
        disabled={disabled || isLoading}
        label={t('reasonForResignation')}
        placeholder={t('enterTheReasonForYourResignation')}
        value={selectedData?.reason || ''}
        changeHandler={e => {
          selectData(prev => ({ ...prev, reason: e.target.value }))
        }}
      />}
    </>
  )
}

export default ReasonSelect